import React from "react";

interface ImportModalFooterProps {
  onClose: () => void;
  onImport: () => void;
  isImportDisabled: boolean;
  isUploading: boolean;
}

export const ImportModalFooter: React.FC<ImportModalFooterProps> = ({
  onClose,
  onImport,
  isImportDisabled,
  isUploading,
}) => {
  return (
    <div className="px-8 py-5 border-t border-slate-100 rounded-b-[24px] bg-white flex flex-row items-center justify-between shrink-0">
      {/* Left footer: View CSV Guide Link */}
      <div className="flex items-center gap-2 text-[14px]">
        <div className="w-5 h-5 rounded-full border border-[#A655F8]/30 flex items-center justify-center text-[#A655F8] text-[12px] font-bold leading-none select-none">
          ?
        </div>
        <span className="text-slate-500 font-medium">Need help?</span>
        <a href="#" className="text-[#A655F8] hover:underline font-semibold flex items-center gap-1">
          View CSV guide
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="stroke-[2.5]">
            <path d="M15 3h6v6" />
            <path d="M10 14 21 3" />
            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
          </svg>
        </a>
      </div>

      {/* Right footer buttons */}
      <div className="flex flex-row items-center gap-3">
        <button
          type="button"
          onClick={onClose}
          className="h-11 px-6 border border-slate-200 hover:bg-slate-50 text-slate-700 font-bold text-[14px] rounded-[12px] bg-white transition-colors focus:outline-none shadow-sm"
        >
          Cancel
        </button>
        <button
          onClick={onImport}
          disabled={isImportDisabled}
          className="h-11 px-6 bg-[#A655F8] text-white font-bold text-[14px] rounded-[12px] flex items-center justify-center gap-2 focus:outline-none select-none cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isUploading ? (
            <span>Importing...</span>
          ) : (
            <>
              <span>Import Influencers</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14" />
                <path d="m12 5 7 7-7 7" />
              </svg>
            </>
          )}
        </button>
      </div>
    </div>
  );
};
